import parseGeoraster from 'georaster'

const TIFF_SIGNATURES = [
  [0x49, 0x49, 0x2a, 0x00],
  [0x4d, 0x4d, 0x00, 0x2a],
  [0x49, 0x49, 0x2b, 0x00],
  [0x4d, 0x4d, 0x00, 0x2b],
]

const DEFAULT_TIMEOUT_MS = 60_000

const hasTiffSignature = (data: ArrayBuffer): boolean => {
  const header = new Uint8Array(data, 0, Math.min(4, data.byteLength))
  return TIFF_SIGNATURES.some(signature => signature.every((byte, i) => header[i] === byte))
}

// georaster 1.6.0 parses inside a web worker that never posts back when parsing fails,
// so its promise never settles; the signature check and the timeout keep callers from hanging.
export const parseGeorasterSafely = async (
  data: ArrayBuffer,
  timeoutMs: number = DEFAULT_TIMEOUT_MS,
): Promise<unknown> => {
  if (!hasTiffSignature(data)) {
    throw new Error('The file is not a TIFF')
  }

  let timeoutId: ReturnType<typeof setTimeout>
  const timeout = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => reject(new Error('Parsing the georaster timed out')), timeoutMs)
  })

  try {
    return await Promise.race([parseGeoraster(data), timeout])
  } finally {
    clearTimeout(timeoutId)
  }
}
